import type { Menu } from '#/global'

// import MultilevelMenuExample from './modules/multilevel.menu.example'

const menu: Menu.recordMainRaw[] = [
  {
    meta: {
      title: 'app.demo',
      icon: 'uim:box',
    },
    children: [
      // MultilevelMenuExample,
    ],
  },
]

export default menu
